import groupingsMixin from '@/mixins/groupings';
import { stripHtml } from '@/utils';

export default {
  mixins: [groupingsMixin],
  data () {
    return {
      activeTabId: null,
      topicsLoading: false,
    };
  },
  props: {
    flashcard: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    assetTrayGrouping () {
      return this.getAssetTrayGrouping(this.flashcard);
    },
    assetTrayTabs () {
      const assetAssociations = this.assetTrayGrouping?.assetAssociations || [];
      return assetAssociations
        .map(association => ({
          association,
          grouping: this.lookupGrouping(association.assetBId),
          rootTopic: this.$store.getters['topics/topics'][association.assetBContext],
        }))
        .filter(record => record.grouping && record.rootTopic)
        .sort((a, b) => a.association.order - b.association.order)
        .map(record => this.buildTabFromRecord(record))
        .filter(Boolean);
    },
    rootTopicIds () {
      const rootTopicIds = this.assetTrayGrouping?.assetAssociations
        .map(aa => aa.assetBContext) || [];
      return rootTopicIds;
    },
    rootTopics () {
      const rootTopics = this.rootTopicIds
        .map(id => this.$store.getters['topics/topics'][id])
        .filter(topic => topic).sort((a, b) => a.order - b.order);
      return rootTopics;
    },
    showAssetTray () {
      return this.$store.getters['ui/showAssetTray'];
    },
    firstTabId () {
      return this.assetTrayTabs[0]?.id || null;
    },
  },
  watch: {
    flashcard () {
      this.activeTabId = this.firstTabId;
      this.fetchRootTopics();
    },
    rootTopicIds () {
      this.fetchRootTopics();
    },
    firstTabId (newId) {
      if (this.activeTabId === null && newId !== null) {
        this.activeTabId = newId;
      }
    },
  },
  mounted () {
    this.activeTabId = this.firstTabId;
    this.fetchRootTopics();
  },
  methods: {
    fetchRootTopics () {
      if (this.topicsLoading) return;
      if (!this.rootTopicIds || this.rootTopicIds.length === 0) return;

      this.topicsLoading = true;
      this.$store.dispatch('topics/load', { ids: this.rootTopicIds })
        .finally(() => {
          this.topicsLoading = false;
        });
    },
    getTopics (grouping) {
      const assetAssociations = (grouping?.assetAssociations || [])
        .filter(aa => aa.assetBType === 'Topic')
        .sort((a, b) => a.order - b.order);
      const topicIds = assetAssociations
        .map(aa => +aa.assetBId)
        .filter(id => id > 0);
      return topicIds.map(id => this.$store.getters['topics/topics'][id]);
    },
    lookupGrouping (assetBId) {
      return +assetBId > 0 ? this.$store.getters['groupings/all'][+assetBId] : null;
    },
    buildTabFromRecord (record) {
      const subTopics = this.getTopics(record.grouping)
        .filter(t => t?.content)
        .map(topic => ({
          id: topic.id,
          title: stripHtml(topic.title),
          content: topic.content,
        }));
      // Tab groupings can arrive without their own topic associations; the tray
      // association's assetBContext root topic then carries the tab's content.
      const hasOwnTopicAssociations = (record.grouping?.assetAssociations || [])
        .some(aa => aa.assetBType === 'Topic');
      if (!hasOwnTopicAssociations && record.rootTopic?.content) {
        subTopics.push({
          id: record.rootTopic.id,
          title: stripHtml(record.rootTopic.title),
          content: record.rootTopic.content,
        });
      }
      if (subTopics.length === 0) return null;
      return {
        id: record.rootTopic.id,
        buttonTitle: stripHtml(record.rootTopic.title),
        subTopics,
        newContent: record.association.displayType === 'new_content',
        order: record.association.order,
      };
    },
    toggleAssetTray () {
      this.$store.commit('ui/setShowAssetTray', !this.showAssetTray);
      if (this.showAssetTray) {
        this.$nextTick(() => {
          const el = document.getElementById('asset-tray');
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        });
      }
    },
  },
};
